import { useEffect, useState } from "react";
import { DashboardSearchWrap, DateBox } from "style/admin/dashboard";
import PeriodSelect, { PeriodOption } from "./dashboard.select";
import DashboardDatepicker from "./dashboard.datepicker";

interface SearchConditionProps {
  startDate: string;
  endDate: string;
}

interface DateProps {
  dateHandeler: (params: {
    startDate: string;
    endDate: string;
    period: string;
  }) => void;
}

const DashboardSearch = ({ dateHandeler }: DateProps) => {
  const [period, setPeriod] = useState<PeriodOption>("weekly");

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const handleSearchSubmit = ({ startDate, endDate }: SearchConditionProps) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  useEffect(() => {
    if (startDate && endDate) {
      dateHandeler({ startDate: startDate, endDate: endDate, period: period });
    }
  }, [startDate, endDate, period]);

  return (
    <DashboardSearchWrap>
      <PeriodSelect value={period} onChange={setPeriod} />
      <DateBox>
        <DashboardDatepicker
          handleSearchSubmit={handleSearchSubmit}
          period={period}
        />
      </DateBox>
    </DashboardSearchWrap>
  );
};

export default DashboardSearch;
